import React from 'react';
import { Logo } from './Logo';
import { getWhatsAppLink } from '../utils/whatsapp';
const FOOTER_WHATSAPP_MESSAGE = 'Hola, equipo de Origen Studio. Quiero conocer más sobre sus sistemas digitales.';
const sistemasLinks = [{
  href: '#sistemas',
  label: 'Presencia Digital'
}, {
  href: '#sistemas',
  label: 'Sistema Comercial'
}, {
  href: '#sistemas',
  label: 'Sistema Completo'
}, {
  href: '#voice',
  label: 'VOICE'
}];
const origenLinks = [{
  href: '#como-funciona',
  label: 'Cómo funciona'
}];
export function Footer() {
  return <footer className="bg-carbon text-arena pt-12 md:pt-16 px-6 md:px-20 pb-12 md:pb-16" data-id="element-13" data-mp="387e5ix8d5do">
      <div className="max-w-[1200px] mx-auto" data-id="element-14" data-mp="3ldkdx4j6scq4">
        <div className="flex flex-col md:flex-row justify-between gap-12 md:gap-24 mb-16" data-id="element-15" data-mp="3qdf3n4r86w9l">
          {/* Left Column */}
          <div className="flex-1" data-id="element-16" data-mp="29ynk7hc24zcf">
            <div className="mb-4" data-id="element-17" data-mp="29xm0ypkw16jm">
              <Logo variant="dark" data-id="element-18" data-mp="2ey9yzv7jannc" />
            </div>
            <p className="font-body text-[14px] text-arena/55 max-w-[360px] leading-relaxed" data-id="element-19" data-mp="2ez1nkm2prl44">
              Sistemas digitales para empresas.
            </p>
          </div>

          {/* Link Columns */}
          <div className="flex-1 md:max-w-[480px] grid grid-cols-3 gap-8" data-id="element-20" data-mp="3gc0hdk3g7u7m">
            <div data-id="element-21" data-mp="3v8rhjvky59ya">
              <span className="block font-body text-[11px] uppercase tracking-[0.12em] text-arena/40 mb-4" data-id="element-22" data-mp="3v9b0nfmc24dw">
                SISTEMAS
              </span>
              <div className="flex flex-col gap-3" data-id="element-23" data-mp="82qt3uy8hxus">
                {sistemasLinks.map(link => <a key={link.label} href={link.href} className="font-body text-[13px] text-arena/50 hover:text-arena/100 transition-opacity duration-150 no-underline" data-id="element-24" data-mp="3477jvnjyo2y">
                    {link.label}
                  </a>)}
              </div>
            </div>
            <div data-id="element-25" data-mp="qtrs2izcttec">
              <span className="block font-body text-[11px] uppercase tracking-[0.12em] text-arena/40 mb-4" data-id="element-26" data-mp="qr5lalkafhx6">
                ORIGEN
              </span>
              <div className="flex flex-col gap-3" data-id="element-27" data-mp="twfovvf7rzsy">
                {origenLinks.map(link => <a key={link.label} href={link.href} className="font-body text-[13px] text-arena/50 hover:text-arena/100 transition-opacity duration-150 no-underline" data-id="element-28" data-mp="yuzbzz5jnhmw">
                    {link.label}
                  </a>)}
                <a href={getWhatsAppLink(FOOTER_WHATSAPP_MESSAGE)} target="_blank" rel="noopener noreferrer" className="font-body text-[13px] text-arena/50 hover:text-arena/100 transition-opacity duration-150 no-underline" data-id="element-29" data-mp="1clcli5y334ec">
                  Contacto
                </a>
              </div>
            </div>
            <div data-id="element-30" data-mp="3oczqrf0zmp85">
              <span className="block font-body text-[11px] uppercase tracking-[0.12em] text-arena/40 mb-4" data-id="element-31" data-mp="3odhuewpzc5q3">
                LEGAL
              </span>
              <div className="flex flex-col gap-3" data-id="element-32" data-mp="2ag5ecolo18fl">
                <span className="font-body text-[13px] text-arena/40 cursor-default" data-id="element-33" data-mp="2agyaywqwuhk0">
                  Privacidad
                </span>
                <span className="font-body text-[13px] text-arena/40 cursor-default" data-id="element-34" data-mp="21m0krxf5diwd">
                  Términos
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Line */}
        <div className="pt-6 border-t border-arena/10" data-id="element-35" data-mp="2tdg3vhhhwnhu">
          <p className="font-body text-[12px] text-arena/30" data-id="element-36" data-mp="2pbuvo9fwoxdz">
            © 2025 Origen Studio · Colombia
          </p>
        </div>
      </div>
    </footer>;
}